import { useEffect, useState } from 'react';
import { getListPromotion } from '../features/dashboard/actions';

function usePromotion(props) {
  const [promo, setPromo] = useState([]);

  const fetchListPromo = async () => {
    try {
      const { data } = await getListPromotion();
      if (data.code === 200) {
        setPromo(data.data.items);
        // setPromo([...data.data.items, ...data.data.items, ...data.data.items]);
      }
    } catch (err) {}
  };
  useEffect(() => {
    fetchListPromo();
  }, []);
  return { promo };
}

export default usePromotion;
